import {createStore as reduxCreateStore, applyMiddleware, combineReducers, compose} from 'redux'

// Middlewares
import {createLogger} from 'redux-logger'
import serviceMiddleware from 'inst-redux-service-middleware'
import alertTimerMiddleware from '../middleware/alertTimerMiddleware'
import courseAccommodationSettingsMiddleware from '../middleware/courseAccommodationSettingsMiddleware'
import saveAccommodationsMiddleware from '../middleware/saveAccommodationsMiddleware'

// Reducers
import alerts from '../reducers/alerts'
import assignmentSessions from '../reducers/assignmentSessions'
import attemptHistory from '../reducers/attemptHistory'
import context from '../reducers/context'
import contentExports from '../reducers/contentExports'
import features from '../reducers/features'
import moderation from '../reducers/moderation'
import oauthToken from '../reducers/oauthToken'
import launchToken from '../reducers/launchToken'
import participantSessions from '../reducers/participantSessions'
import preview from '../reducers/preview'
import sidebar from '../reducers/sidebar'
import courseAccommodationSettings from '../reducers/courseAccommodationSettings'
import giveExtraAttemptsSettings from '../reducers/giveExtraAttempts'
import giveExtraTimeSettings from '../reducers/giveExtraTime'
import reduceAnswerChoicesSettings from '../reducers/reduceAnswerChoices'
import users from '../reducers/users'
import ux from '../reducers/ux'
import versions from '../reducers/versions'
import coolingPeriodTimer from '../reducers/coolingPeriodTimer'
import header from '../reducers/header'
import appSync from '../reducers/appSync'

// Services
import LtiApiService from '../services/LtiApiService'

export function configureStore() {
  const loggerMiddleware = createLogger({collapsed: true})

  const reducers = combineReducers({
    alerts,
    assignmentSessions,
    attemptHistory,
    context,
    coolingPeriodTimer,
    contentExports,
    features,
    moderation,
    oauthToken,
    launchToken,
    participantSessions,
    preview,
    sidebar,
    courseAccommodationSettings,
    giveExtraAttemptsSettings,
    giveExtraTimeSettings,
    reduceAnswerChoicesSettings,
    users,
    ux,
    versions,
    header,
    appSync,
  })

  const productionMiddleware = [
    alertTimerMiddleware,
    courseAccommodationSettingsMiddleware,
    saveAccommodationsMiddleware,
    serviceMiddleware({ltiApi: new LtiApiService()}),
  ]

  const middleware =
    process.env.NODE_ENV === 'production'
      ? productionMiddleware
      : [...productionMiddleware, loggerMiddleware]

  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
  const store = reduxCreateStore(
    reducers,
    undefined,
    composeEnhancers(applyMiddleware(...middleware)),
  )
  return store
}

export default configureStore
